import { render, staticRenderFns } from "./DerbyLeagueList.vue?vue&type=template&id=27e0a3a8&"
import script from "./DerbyLeagueList.vue?vue&type=script&lang=js&"
export * from "./DerbyLeagueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports